var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { fromJS as Immutable } from 'immutable';
import { createSelector } from 'reselect';
import { Icon } from "../../UI";
import { I18NLink } from "../../I18N";
import { NeedAuthorization } from "../../Auth";
import { withContext } from "../../componentWrappers";
import ShowIf from "../../App/ShowIf";
import { deleteReference } from "../actions/referencesActions";
import {
  highlightReference,
  activateReference,
  selectReference,
  toggleReferences } from "../actions/uiActions";

import { Item } from "../../Layout";
import helpers from "../../Documents/helpers";

const selectDoc = createSelector(
  (s) => s.documentViewer.targetDoc,
  (s) => s.documentViewer.doc,
  (targetDoc, doc) =>
  targetDoc.get('_id') ?
  helpers.performantDocToJSWithoutRelations(targetDoc) :
  helpers.performantDocToJSWithoutRelations(doc)
);

class Connection extends Component {
  clickReference(reference) {
    if (this.props.readOnly) {
      return;
    }

    if (!this.props.targetDoc) {
      this.props.activateReference(reference, this.props.referencesSection);
    }

    if (this.props.targetDoc && typeof reference.reference !== 'undefined') {
      this.props.selectReference(reference);
    }

    this.props.toggleReferences(true);
  }

  deleteReference(reference) {
    this.props.mainContext.confirm({
      accept: () => {
        this.props.deleteReference(reference);
      },
      title: 'Confirm delete connection',
      message: 'Are you sure you want to delete this connection?'
    });
  }

  relationType(id) {
    const type = this.props.relationTypes.find((relation) => relation.get('_id') === id);
    if (type) {
      return type.name;
    }
  }

  render() {
    const { reference } = this.props;
    let itemClass = '';
    const disabled = this.props.targetDoc && typeof reference.reference === 'undefined';

    if (this.props.highlighted) {
      itemClass = 'relationship-hover';
    }

    if (this.props.active) {
      itemClass = 'relationship-active';
    }

    if (this.props.active && this.props.targetDoc && this.props.targetRange) {
      itemClass = 'relationship-selected';
    }

    if (this.props.readOnly) {
      itemClass = '';
    }

    const doc = Immutable(reference.associatedRelationship.entityData);
    return (/*#__PURE__*/
      _jsx(Item, {
        onMouseEnter: this.props.highlightReference.bind(null, reference._id),
        onMouseLeave: this.props.highlightReference.bind(null, null),
        onClick: this.clickReference.bind(this, reference),
        doc: doc,
        noMetadata: true,
        className: `${itemClass} item-${reference._id} ${disabled ? 'disabled' : ''} ${
        this.props.readOnly ? 'readOnly' : ''}`,

        "data-id": reference._id,
        additionalText:
        reference.associatedRelationship.reference ?
        reference.associatedRelationship.reference.text :
        null,

        additionalMetadata: [
        { label: 'Connection type', value: this.relationType(reference.template) }],

        evalPublished: true,
        buttons: /*#__PURE__*/
        _jsx("div", { className: "item-shortcut-group" }, void 0, /*#__PURE__*/
        _jsx(ShowIf, { if: !this.props.targetDoc && !this.props.readOnly }, void 0, /*#__PURE__*/
        _jsx(NeedAuthorization, { roles: ['admin', 'editor'] }, void 0, /*#__PURE__*/
        _jsx("a", {
          className: "item-shortcut btn btn-default btn-hover-danger delete",
          onClick: this.deleteReference.bind(this, reference) }, void 0, /*#__PURE__*/

        _jsx(Icon, { icon: "trash-alt" })
        )
        )
        ), /*#__PURE__*/

        _jsx(ShowIf, { if: !this.props.targetDoc }, void 0, /*#__PURE__*/
        _jsx(I18NLink, {
          to: `/entity/${doc.get('sharedId')}`,
          onClick: (e) => e.stopPropagation(),
          className: "item-shortcut btn btn-default" }, void 0, /*#__PURE__*/

        _jsx(Icon, { icon: "file" })
        )
        )
        ) }

      ));

  }
}

Connection.defaultProps = {
  targetDoc: false
};




















const mapStateToProps = (state, ownProps) => {var _documentViewer$uiSta;
  const { documentViewer } = state;
  const isActive = documentViewer.uiState.get('activeReference') ?
  documentViewer.uiState.get('activeReference') === ownProps.reference._id : (_documentViewer$uiSta =
  documentViewer.uiState.get('activeReferences')) === null || _documentViewer$uiSta === void 0 ? void 0 : _documentViewer$uiSta.includes(ownProps.reference._id);

  return {
    highlighted: documentViewer.uiState.get('highlightedReference') === ownProps.reference._id,
    active: isActive || false,
    targetRange: documentViewer.uiState.get('reference').get('targetRange'),
    targetDoc: !!documentViewer.targetDoc.get('_id'),
    relationTypes: documentViewer.relationTypes,
    doc: selectDoc(state)
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      highlightReference,
      activateReference,
      selectReference,
      deleteReference,
      toggleReferences
    },
    dispatch
  );
}

export { Connection };
export default connect(mapStateToProps, mapDispatchToProps)(withContext(Connection));